import { useResourceCenterArticle } from 'app/templates/ResourceCenterArticle/useResourceCenterArticle';
import Grid from 'atoms/Layout/Grid/Grid';
import ImageCardCarouselWithTextBlock from 'molecules/ImageCardCarouselWithTextBlock/ImageCardCarouselWithTextBlock';
import React from 'react';
import { ImageCardProps } from 'molecules/ImageCard/ImageCard';

const MoreLikeThis = (): JSX.Element => {
  const { otherArticles } = useResourceCenterArticle();

  const cards: ImageCardProps[] = otherArticles.map((article) => {
    return {
      href: `/resources/${article.slug}`,
      image: {
        image: article.heroImage.gatsbyImageData,
        alt: article.title,
      },
      imageHeight: 200,
      imageCover: true,
      title: {
        type: 'paragraph',
        text: article.title,
        size: 'lg',
        fontWeight: 'font-weight-semibold',
        textAlign: 'left',
      },
    };
  });

  return (
    <Grid
      totalColumns={1}
      gap='spacing-4xl'
    >
      <ImageCardCarouselWithTextBlock
        heading={{
          type: 'heading',
          text: 'More like this',
          size: 'md',
        }}
        cards={cards}
      />
    </Grid>
  );
};

export default MoreLikeThis;
